var 
  //local variable
  user,
  accountId,
  profiles = {},
  family,
  lastFamilyId, //this one should not be cleared on reset
  state,
  thecache = {},
  thecacheWall = {},
  families = [],
  invitations = [],
  medias = {},
  settingsPerFamily;

export function reset(){
  user = accountId = family = state = settingsPerFamily = undefined;
  profiles = {};
  thecache = {};
  thecacheWall = {};
  medias = {};
  families = [];
  invitations = [];
}

export function setSettingsPerFamily(s){
  settingsPerFamily = s;
}
export function getSettingsPerFamily(){
  return settingsPerFamily;
}

export function setFamily(obj){
  family = obj;
  if(obj){
    lastFamilyId = obj.metaId;
    
    profiles = {};
    obj.members.forEach(function(member){
      profiles[member.accountId] = member;
      if (member.isloggedaccount) {
        user = member;
        accountId = user.accountId;
      }
      
    });
  }
}
export function getFamily(id :string = undefined){
  if(!id){
    return family;
  }
  for(var i=0;i<families.length;i++){
    if(families[i].metaId===id){
      return families[i];
    }
  }
}
export function getLastFamilyId(){
  return lastFamilyId;
}
export function setFamilies(obj){
  families=obj;
}
export function getFamilies(){
  if(families && family){
    for(var i=0;i<families.length;i++){
      if(families[i].metaId===family.metaId){
        families[i] = families[0];
        families[0] = family;
        break;
      }
    }
  }  
  return families;
}
export function setInvitations(obj){
  invitations=obj;
}
export function getInvitations(){
  return invitations;
}
export function getUser(){
  return user;
}
export function getAccountId(){
  return accountId;
}
export function setProfiles(newProfiles){
  // we add only ghostprofile ExtendedFamilymember are already here
  for(var accountId in newProfiles){
    var profile = newProfiles[accountId];
    if(profiles[accountId]===undefined){
      profiles[accountId] = profile;
    }else{
      profiles[accountId].profileId = profile.metaId;
    }
  }
}
export function getProfile(id){
  id = id || accountId;
  if(typeof id ==='string' && id.indexOf('family/')===0){
    return family;
  }
  //TODO log when the or is usefull
  return profiles[id]||{name:'"?"'};
}
export function setState(stateArg){
  state = stateArg;
}
export function getState(){
  return state;
}
export function cache(obj){
  thecache[obj.metaId] = obj;
}
export function get(id){
  return thecache[id];
}
export function cacheWall(obj){
  thecacheWall[obj.metaId] = obj;
}
export function cacheIMedia(obj){
  medias[obj.metaId] = obj;
}
export function getIMedia(id){
  return medias[id];
}

export function getWall(id){
  return thecacheWall[id]||thecache[id];
}

export function getPermission(permissionName){
  //no rewrite if no state
  if(!state){
    return permissionName;
  }
  var 
    premiumBean = state.premium,
    data = premiumBean[permissionName];

  //if it is a function we execute it
  if(typeof data === 'function'){
    data = data.apply(premiumBean /*TODO add arguments of function*/);
  }
  //if it is undefined it is ok, it means that nothing has been set for the current partner
  if(data===undefined || data===true){
    data=permissionName;
  }

  return data;
}
export function mergeSyncBean<T extends {metaId:string}>(syncBean :SyncBean<T>, cachedArray :T[]){
  if(syncBean.isSync){
    syncBean.deletedIds.forEach(function(id){
      delete thecache[id];
      //remove deleted  
      for(let i=cachedArray.length-1;i>=0;i--){
        if(cachedArray[i].metaId===id){
          cachedArray.splice(i,1);
        }
      }
    });
    //remove updated  
    syncBean.updatedCreated.forEach(function(newobj){
      for(let i=cachedArray.length-1;i>=0;i--){
        if(cachedArray[i].metaId===newobj.metaId){
          cachedArray.splice(i,1);
        }
      }
    });
  }else{
    cachedArray.length=0;
  }
  syncBean.updatedCreated.forEach(function(newobj){
    cache(newobj);
    cachedArray.push(newobj);
  });
}
window["FwDatas"] = {get,getUser};